export default __webpack_public_path__ + "static/media/Sharjah-Research-Technology-and-Innovation-Park.ece80b72.mp4";